export default __webpack_public_path__ + "static/media/dual_logo_white.dd682da2.png";